// ENARM Match - Datos y Catálogos (100% Determinístico)
// NO modificar sin autorización - Catálogos cerrados

// =============================================================================
// EJES DEL MODELO (0-3)
// =============================================================================
export const EJES = [
  { id: 'agudo', name: 'Agudo', description: 'Urgencias, decisiones rápidas, presión alta' },
  { id: 'longitudinal', name: 'Longitudinal', description: 'Seguimiento, continuidad, relación a largo plazo' },
  { id: 'cognitivo', name: 'Cognitivo', description: 'Razonamiento complejo, diagnóstico diferencial' },
  { id: 'procedimientos', name: 'Procedimientos', description: 'Intervenciones, técnicas manuales' },
  { id: 'quirofano', name: 'Quirófano', description: 'Cirugía, ambiente quirúrgico' },
  { id: 'emocional', name: 'Emocional', description: 'Carga emocional, comunicación difícil' },
  { id: 'imagen', name: 'Imagen', description: 'Interpretación de estudios, trabajo en pantalla' },
  { id: 'sistema', name: 'Sistema', description: 'Salud pública, poblaciones, gestión' },
  { id: 'pediatria', name: 'Pediatría', description: 'Atención a niños y adolescentes' }
];

// =============================================================================
// PREGUNTAS PARES FORZADOS (A/B) - MODO COMPLETO: 10 preguntas
// =============================================================================
export const PREGUNTAS_PARES_FORZADOS = [
  {
    id: 1,
    pregunta: '¿Qué prefieres?',
    opcionA: 'Resolver casos complejos con razonamiento fino',
    opcionB: 'Procedimientos con impacto inmediato',
    mapeoA: { cognitivo: 1 },
    mapeoB: { procedimientos: 1 }
  },
  {
    id: 2,
    pregunta: '¿Qué ambiente te atrae más?',
    opcionA: 'Urgencia y decisión rápida',
    opcionB: 'Seguimiento y continuidad con pacientes',
    mapeoA: { agudo: 1 },
    mapeoB: { longitudinal: 1 }
  },
  {
    id: 3,
    pregunta: '¿Cómo te sientes respecto al quirófano?',
    opcionA: 'Me gusta el quirófano',
    opcionB: 'Prefiero fuera del quirófano',
    mapeoA: { quirofano: 1 },
    mapeoB: { quirofano: -1 }
  },
  {
    id: 4,
    pregunta: '¿Qué tipo de trabajo prefieres?',
    opcionA: 'Interpretar imágenes y estudios',
    opcionB: 'Clínica directa con el paciente',
    mapeoA: { imagen: 1 },
    mapeoB: { cognitivo: 1 }
  },
  {
    id: 5,
    pregunta: '¿Qué tipo de interacciones prefieres?',
    opcionA: 'Conversaciones emocionales difíciles',
    opcionB: 'Casos técnicos con menor carga emocional',
    mapeoA: { emocional: 1 },
    mapeoB: { emocional: -1 }
  },
  {
    id: 6,
    pregunta: '¿Cuál es tu enfoque preferido?',
    opcionA: 'Mejorar sistemas y poblaciones',
    opcionB: 'Atender al paciente individual',
    mapeoA: { sistema: 1 },
    mapeoB: { cognitivo: 1 }
  },
  {
    id: 7,
    pregunta: '¿Con qué grupo etario prefieres trabajar?',
    opcionA: 'Niños',
    opcionB: 'Adultos',
    mapeoA: { pediatria: 1 },
    mapeoB: { pediatria: -1 }
  },
  {
    id: 8,
    pregunta: '¿Qué ritmo de trabajo prefieres?',
    opcionA: 'Ritmo impredecible y variado',
    opcionB: 'Agenda programada y predecible',
    mapeoA: { agudo: 1 },
    mapeoB: { longitudinal: 1 }
  },
  {
    id: 9,
    pregunta: '¿Qué tipo de actividad disfrutas más?',
    opcionA: 'Trabajo manual y técnico',
    opcionB: 'Decisiones terapéuticas y manejo',
    mapeoA: { procedimientos: 1 },
    mapeoB: { cognitivo: 1 }
  },
  {
    id: 10,
    pregunta: '¿Dónde te ves trabajando?',
    opcionA: 'Laboratorio, patología o análisis de datos',
    opcionB: 'Clínica de cama y respuesta directa',
    mapeoA: { cognitivo: 1 },
    mapeoB: { longitudinal: 1 }
  }
];

// =============================================================================
// TOLERANCIAS (ESCALA 0-4)
// 0 = No lo tolero, 4 = Lo tolero bien
// =============================================================================
export const TOLERANCIAS = [
  { id: 'guardias', label: 'Guardias y desvelo', flagKey: 'no_guardias', flagThreshold: 1 },
  { id: 'quirofano_sangre', label: 'Quirófano y sangre', flagKey: 'aversion_quirofano', flagThreshold: 1 },
  { id: 'urgencias', label: 'Urgencias y presión alta', flagKey: null, flagThreshold: null },
  { id: 'rutina', label: 'Rutina repetitiva', flagKey: null, flagThreshold: null },
  { id: 'incertidumbre', label: 'Incertidumbre diagnóstica', flagKey: null, flagThreshold: null },
  { id: 'emocional_intenso', label: 'Trato emocional intenso', flagKey: 'aversion_emocional', flagThreshold: 1 },
  { id: 'ninos', label: 'Niños', flagKey: 'no_ninos', flagThreshold: 1 },
  { id: 'radiacion', label: 'Radiación/pantallas/imagen todo el día', flagKey: 'aversion_radiacion', flagThreshold: 1 }
];

// =============================================================================
// ADN DE ESPECIALIDADES ENARM (MVP: 10 especialidades)
// Valores de 0-3 por cada eje
// =============================================================================
export const ADN_ESPECIALIDADES = {
  'medicina_interna': {
    id: 'medicina_interna',
    nombre: 'Medicina Interna',
    abreviatura: 'MI',
    ejes: { agudo: 2, longitudinal: 3, cognitivo: 3, procedimientos: 1, quirofano: 0, emocional: 2, imagen: 1, sistema: 1, pediatria: 0 }
  },
  'cirugia_general': {
    id: 'cirugia_general',
    nombre: 'Cirugía General',
    abreviatura: 'CG',
    ejes: { agudo: 3, longitudinal: 1, cognitivo: 1, procedimientos: 3, quirofano: 3, emocional: 1, imagen: 1, sistema: 0, pediatria: 0 }
  },
  'pediatria': {
    id: 'pediatria',
    nombre: 'Pediatría',
    abreviatura: 'PED',
    ejes: { agudo: 2, longitudinal: 3, cognitivo: 2, procedimientos: 1, quirofano: 0, emocional: 2, imagen: 1, sistema: 0, pediatria: 3 }
  },
  'ginecologia_obstetricia': {
    id: 'ginecologia_obstetricia',
    nombre: 'Ginecología y Obstetricia',
    abreviatura: 'GO',
    ejes: { agudo: 3, longitudinal: 2, cognitivo: 2, procedimientos: 3, quirofano: 2, emocional: 2, imagen: 1, sistema: 0, pediatria: 1 }
  },
  'urgencias': {
    id: 'urgencias',
    nombre: 'Urgencias Médico-Quirúrgicas',
    abreviatura: 'URG',
    ejes: { agudo: 3, longitudinal: 1, cognitivo: 2, procedimientos: 2, quirofano: 0, emocional: 2, imagen: 1, sistema: 0, pediatria: 1 }
  },
  'anestesiologia': {
    id: 'anestesiologia',
    nombre: 'Anestesiología',
    abreviatura: 'ANES',
    ejes: { agudo: 3, longitudinal: 1, cognitivo: 2, procedimientos: 3, quirofano: 2, emocional: 1, imagen: 1, sistema: 0, pediatria: 0 }
  },
  'imagenologia': {
    id: 'imagenologia',
    nombre: 'Imagenología Diagnóstica y Terapéutica',
    abreviatura: 'IMG',
    ejes: { agudo: 1, longitudinal: 1, cognitivo: 3, procedimientos: 1, quirofano: 0, emocional: 0, imagen: 3, sistema: 0, pediatria: 0 }
  },
  'psiquiatria': {
    id: 'psiquiatria',
    nombre: 'Psiquiatría',
    abreviatura: 'PSIQ',
    ejes: { agudo: 1, longitudinal: 3, cognitivo: 3, procedimientos: 0, quirofano: 0, emocional: 3, imagen: 0, sistema: 0, pediatria: 0 }
  },
  'medicina_familiar': {
    id: 'medicina_familiar',
    nombre: 'Medicina Familiar',
    abreviatura: 'MF',
    ejes: { agudo: 1, longitudinal: 3, cognitivo: 2, procedimientos: 1, quirofano: 0, emocional: 2, imagen: 0, sistema: 1, pediatria: 1 }
  },
  'traumatologia_ortopedia': {
    id: 'traumatologia_ortopedia',
    nombre: 'Traumatología y Ortopedia',
    abreviatura: 'TO',
    ejes: { agudo: 3, longitudinal: 1, cognitivo: 1, procedimientos: 3, quirofano: 3, emocional: 1, imagen: 1, sistema: 0, pediatria: 0 }
  },
  'otras_especialidades': {
    id: 'otras_especialidades',
    nombre: 'Otras Especialidades',
    abreviatura: 'OTRAS',
    ejes: { agudo: 1, longitudinal: 2, cognitivo: 2, procedimientos: 1, quirofano: 0, emocional: 1, imagen: 1, sistema: 1, pediatria: 1 }
  }
};

// =============================================================================
// SUBESPECIALIDADES POR TRONCO COMÚN (lista completa oficial)
// =============================================================================
export const SUBESPECIALIDADES_POR_TRONCO = {
  'medicina_interna': [
    'Cardiología',
    'Nefrología',
    'Gastroenterología',
    'Neumología',
    'Endocrinología',
    'Reumatología',
    'Neurología',
    'Infectología',
    'Hematología',
    'Oncología Médica',
    'Geriatría',
    'Alergia e Inmunología',
    'Dermatología',
    'Medicina Crítica',
    'Angiología y Cirugía Vascular'
  ],
  'cirugia_general': [
    'Cirugía Plástica y Reconstructiva',
    'Cirugía Oncológica',
    'Cirugía Cardiovascular y Torácica',
    'Coloproctología',
    'Cirugía de Trasplantes',
    'Urología',
    'Neurocirugía'
  ],
  'pediatria': [
    'Neonatología',
    'Cardiología Pediátrica',
    'Oncología Pediátrica',
    'Nefrología Pediátrica',
    'Neurología Pediátrica',
    'Infectología Pediátrica',
    'Gastroenterología Pediátrica',
    'Medicina Crítica Pediátrica'
  ],
  'ginecologia_obstetricia': [
    'Biología de la Reproducción Humana',
    'Medicina Materno Fetal',
    'Ginecología Oncológica',
    'Uroginecología'
  ],
  'urgencias': [
    'Medicina Crítica (Terapia Intensiva)',
    'Toxicología Clínica'
  ],
  'anestesiologia': [
    'Clínica del Dolor (Algología)',
    'Cuidados Paliativos',
    'Anestesiología Cardiovascular',
    'Anestesia Pediátrica'
  ],
  'imagenologia': [
    'Radiología Intervencionista',
    'Neuroradiología',
    'Radiología Pediátrica'
  ],
  'psiquiatria': [
    'Psiquiatría Infantil',
    'Adicciones'
  ],
  'traumatologia_ortopedia': [
    'Cirugía de Mano',
    'Cirugía de Columna',
    'Ortopedia Pediátrica',
    'Artroscopia y Medicina Deportiva'
  ],
  'otras_especialidades': [
    'Oftalmología Quirúrgica',
    'Otorrinolaringología Pediátrica',
    'Audiología y Otoneurología',
    'Cirugía Pediátrica',
    'Medicina Nuclear',
    'Radio Oncología',
    'Terapia Endovascular Neurológica',
    'Neurofisiología Clínica',
    'Neuroanestesiología',
    'Hematología Pediátrica',
    'Neumología Pediátrica',
    'Reumatología Pediátrica',
    'Urgencias Pediátricas',
    'Alergia Pediátrica',
    'Medicina Paliativa y del Dolor',
    'Patología Clínica',
    'Genética Médica',
    'Medicina de Rehabilitación',
    'Medicina del Deporte',
    'Epidemiología y Salud Pública',
    'Medicina Preventiva',
    'Calidad de la Atención Clínica'
  ]
};

// =============================================================================
// DATASET DESTINOS 10 AÑOS (CSV PARSEADO)
// Incluye: Troncos Comunes + Subespecialidades
// =============================================================================
export const DESTINOS_10_ANIOS = [
  // =====================================================
  // TRONCOS COMUNES (Especialidades directas ENARM)
  // =====================================================
  {
    destino_id: 'TC01',
    destino_nombre: 'Anatomía Patológica',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['anatomia_patologica'],
    descripcion_dia_a_dia: 'Laboratorio, microscopía, diagnóstico histopatológico, biopsias.',
    tronco_requisitos_duros: ['laboratorio', 'cognitivo'],
    flags_conflicto_tipicos: [],
    alternativas_si_no_toleras_tronco: ['Patología Clínica:enfoque laboratorio']
  },
  {
    destino_id: 'TC02',
    destino_nombre: 'Anestesiología',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['anestesiologia'],
    descripcion_dia_a_dia: 'Quirófano diario, procedimientos, monitorización, guardias.',
    tronco_requisitos_duros: ['quirofano', 'procedimientos'],
    flags_conflicto_tipicos: ['aversion_quirofano'],
    alternativas_si_no_toleras_tronco: ['MI:si prefieres fuera de quirófano']
  },
  {
    destino_id: 'TC03',
    destino_nombre: 'Audiología, Otoneurología y Foniatría',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['audiologia'],
    descripcion_dia_a_dia: 'Consulta especializada, estudios audiológicos, rehabilitación auditiva y del lenguaje.',
    tronco_requisitos_duros: ['consulta', 'tecnologia'],
    flags_conflicto_tipicos: [],
    alternativas_si_no_toleras_tronco: ['ORL:si prefieres quirúrgico']
  },
  {
    destino_id: 'TC04',
    destino_nombre: 'Calidad de la Atención Clínica',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['calidad'],
    descripcion_dia_a_dia: 'Gestión hospitalaria, indicadores, seguridad del paciente, protocolos.',
    tronco_requisitos_duros: ['administrativo', 'cognitivo'],
    flags_conflicto_tipicos: [],
    alternativas_si_no_toleras_tronco: ['Epidemiología:enfoque poblacional']
  },
  {
    destino_id: 'TC05',
    destino_nombre: 'Cirugía General',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['cirugia_general'],
    descripcion_dia_a_dia: 'Quirófano, urgencias, guardias pesadas, trauma, abdomen.',
    tronco_requisitos_duros: ['quirofano', 'guardias', 'agudo'],
    flags_conflicto_tipicos: ['aversion_quirofano', 'no_guardias'],
    alternativas_si_no_toleras_tronco: ['MI:si prefieres menos quirófano']
  },
  {
    destino_id: 'TC06',
    destino_nombre: 'Epidemiología',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['epidemiologia'],
    descripcion_dia_a_dia: 'Vigilancia epidemiológica, salud pública, estadística, investigación.',
    tronco_requisitos_duros: ['cognitivo', 'administrativo'],
    flags_conflicto_tipicos: [],
    alternativas_si_no_toleras_tronco: ['Med Preventiva:enfoque comunitario']
  },
  {
    destino_id: 'TC07',
    destino_nombre: 'Genética Médica',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['genetica'],
    descripcion_dia_a_dia: 'Consulta genética, asesoramiento, diagnóstico de enfermedades hereditarias.',
    tronco_requisitos_duros: ['consulta', 'cognitivo'],
    flags_conflicto_tipicos: [],
    alternativas_si_no_toleras_tronco: ['Patología:enfoque laboratorio']
  },
  {
    destino_id: 'TC08',
    destino_nombre: 'Geriatría',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['geriatria'],
    descripcion_dia_a_dia: 'Consulta + hospital, adulto mayor, polifarmacia, fragilidad.',
    tronco_requisitos_duros: ['consulta', 'cronicidad', 'comunicacion'],
    flags_conflicto_tipicos: [],
    alternativas_si_no_toleras_tronco: ['MI:si prefieres más agudo', 'MF:longitudinal']
  },
  {
    destino_id: 'TC09',
    destino_nombre: 'Ginecología y Obstetricia',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['ginecologia_obstetricia'],
    descripcion_dia_a_dia: 'Consulta + partos + cesáreas, guardias obstétricas, salud de la mujer.',
    tronco_requisitos_duros: ['quirofano', 'guardias', 'mujer'],
    flags_conflicto_tipicos: ['aversion_quirofano', 'no_guardias'],
    alternativas_si_no_toleras_tronco: ['MF:salud reproductiva sin quirófano']
  },
  {
    destino_id: 'TC10',
    destino_nombre: 'Imagenología Diagnóstica y Terapéutica',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['imagenologia'],
    descripcion_dia_a_dia: 'Lectura de estudios, trabajo en pantalla, menos contacto directo.',
    tronco_requisitos_duros: ['pantalla', 'imagen'],
    flags_conflicto_tipicos: ['aversion_radiacion'],
    alternativas_si_no_toleras_tronco: ['MI:si prefieres más contacto']
  },
  {
    destino_id: 'TC11',
    destino_nombre: 'Medicina de la Actividad Física y Deportiva',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['medicina_deporte'],
    descripcion_dia_a_dia: 'Consulta deportiva, valoración funcional, prevención de lesiones, rehabilitación.',
    tronco_requisitos_duros: ['consulta', 'actividad_fisica'],
    flags_conflicto_tipicos: [],
    alternativas_si_no_toleras_tronco: ['Rehabilitación:enfoque funcional']
  },
  {
    destino_id: 'TC12',
    destino_nombre: 'Medicina de Rehabilitación',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['rehabilitacion'],
    descripcion_dia_a_dia: 'Consulta, terapia física, discapacidad, seguimiento funcional.',
    tronco_requisitos_duros: ['consulta', 'longitudinal'],
    flags_conflicto_tipicos: [],
    alternativas_si_no_toleras_tronco: ['MF:si prefieres más integral', 'Deporte:si prefieres activo']
  },
  {
    destino_id: 'TC13',
    destino_nombre: 'Medicina de Urgencias',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['urgencias'],
    descripcion_dia_a_dia: 'Área de choque, decisiones rápidas, turnos variables, alta presión.',
    tronco_requisitos_duros: ['guardias', 'agudo'],
    flags_conflicto_tipicos: ['no_guardias'],
    alternativas_si_no_toleras_tronco: ['MI:si prefieres menos urgencia']
  },
  {
    destino_id: 'TC14',
    destino_nombre: 'Medicina del Trabajo y Ambiental',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['medicina_trabajo'],
    descripcion_dia_a_dia: 'Salud ocupacional, riesgos laborales, dictámenes, prevención.',
    tronco_requisitos_duros: ['administrativo', 'consulta'],
    flags_conflicto_tipicos: [],
    alternativas_si_no_toleras_tronco: ['Epidemiología:enfoque poblacional']
  },
  {
    destino_id: 'TC15',
    destino_nombre: 'Medicina Familiar',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['medicina_familiar'],
    descripcion_dia_a_dia: 'Consulta integral, prevención, todas las edades, comunidad.',
    tronco_requisitos_duros: ['consulta', 'longitudinal'],
    flags_conflicto_tipicos: [],
    alternativas_si_no_toleras_tronco: ['MI:si prefieres más hospital']
  },
  {
    destino_id: 'TC16',
    destino_nombre: 'Medicina Interna',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['medicina_interna'],
    descripcion_dia_a_dia: 'Hospital + consulta, casos complejos, manejo integral del adulto, guardias.',
    tronco_requisitos_duros: ['hospital', 'guardias', 'cognitivo'],
    flags_conflicto_tipicos: ['no_guardias'],
    alternativas_si_no_toleras_tronco: ['MF:si prefieres menos hospital']
  },
  {
    destino_id: 'TC17',
    destino_nombre: 'Medicina Nuclear e Imagenología Molecular',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['medicina_nuclear'],
    descripcion_dia_a_dia: 'Estudios de imagen funcional, radiofármacos, diagnóstico molecular.',
    tronco_requisitos_duros: ['imagen', 'tecnologia'],
    flags_conflicto_tipicos: ['aversion_radiacion'],
    alternativas_si_no_toleras_tronco: ['IMG:si prefieres imagen convencional']
  },
  {
    destino_id: 'TC18',
    destino_nombre: 'Medicina Paliativa',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['paliativa'],
    descripcion_dia_a_dia: 'Cuidado de pacientes terminales, manejo del dolor, acompañamiento.',
    tronco_requisitos_duros: ['emocional', 'comunicacion', 'consulta'],
    flags_conflicto_tipicos: ['aversion_emocional'],
    alternativas_si_no_toleras_tronco: ['MI:si prefieres más agudo']
  },
  {
    destino_id: 'TC19',
    destino_nombre: 'Medicina Preventiva',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['medicina_preventiva'],
    descripcion_dia_a_dia: 'Salud pública, programas de prevención, vacunación, políticas de salud.',
    tronco_requisitos_duros: ['administrativo', 'cognitivo'],
    flags_conflicto_tipicos: [],
    alternativas_si_no_toleras_tronco: ['Epidemiología:enfoque estadístico']
  },
  {
    destino_id: 'TC20',
    destino_nombre: 'Neumología',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['neumologia'],
    descripcion_dia_a_dia: 'EPOC, asma, sueño, hospital por exacerbaciones, broncoscopia.',
    tronco_requisitos_duros: ['hospital', 'cronicidad'],
    flags_conflicto_tipicos: ['no_guardias'],
    alternativas_si_no_toleras_tronco: ['MF:respiratorio', 'IMG:si te gusta imagen']
  },
  {
    destino_id: 'TC21',
    destino_nombre: 'Oftalmología',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['oftalmologia'],
    descripcion_dia_a_dia: 'Consulta, microcirugía ocular, procedimientos láser, consultorio.',
    tronco_requisitos_duros: ['procedimientos', 'consulta'],
    flags_conflicto_tipicos: [],
    alternativas_si_no_toleras_tronco: ['ORL:si prefieres otra área quirúrgica']
  },
  {
    destino_id: 'TC22',
    destino_nombre: 'Otorrinolaringología y Cirugía de Cabeza y Cuello',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['otorrinolaringologia'],
    descripcion_dia_a_dia: 'Quirófano + consulta, cirugía de oído/nariz/garganta, guardias.',
    tronco_requisitos_duros: ['quirofano', 'procedimientos'],
    flags_conflicto_tipicos: ['aversion_quirofano'],
    alternativas_si_no_toleras_tronco: ['Audiología:sin quirófano']
  },
  {
    destino_id: 'TC23',
    destino_nombre: 'Patología Clínica',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['patologia_clinica'],
    descripcion_dia_a_dia: 'Laboratorio clínico, interpretación de pruebas, control de calidad.',
    tronco_requisitos_duros: ['laboratorio', 'cognitivo'],
    flags_conflicto_tipicos: [],
    alternativas_si_no_toleras_tronco: ['Anatomía Patológica:si prefieres microscopía']
  },
  {
    destino_id: 'TC24',
    destino_nombre: 'Pediatría',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['pediatria'],
    descripcion_dia_a_dia: 'Consulta + hospital pediátrico, guardias, niños de todas edades.',
    tronco_requisitos_duros: ['pediatria', 'guardias', 'hospital'],
    flags_conflicto_tipicos: ['no_ninos', 'no_guardias'],
    alternativas_si_no_toleras_tronco: ['MF:si prefieres menos guardias']
  },
  {
    destino_id: 'TC25',
    destino_nombre: 'Psiquiatría',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['psiquiatria'],
    descripcion_dia_a_dia: 'Consulta, psicofármacos, relación terapéutica, carga emocional.',
    tronco_requisitos_duros: ['emocional', 'comunicacion'],
    flags_conflicto_tipicos: ['aversion_emocional'],
    alternativas_si_no_toleras_tronco: ['MF:si prefieres menos carga emocional']
  },
  {
    destino_id: 'TC26',
    destino_nombre: 'Radio Oncología',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['radio_oncologia'],
    descripcion_dia_a_dia: 'Radioterapia, planeación de tratamiento oncológico, seguimiento.',
    tronco_requisitos_duros: ['tecnologia', 'imagen'],
    flags_conflicto_tipicos: ['aversion_radiacion'],
    alternativas_si_no_toleras_tronco: ['Oncología Médica:sin radiación']
  },
  {
    destino_id: 'TC27',
    destino_nombre: 'Traumatología y Ortopedia',
    categoria: 'TroncoComun',
    troncos_habilitantes: ['traumatologia_ortopedia'],
    descripcion_dia_a_dia: 'Quirófano, fracturas, urgencias trauma, guardias pesadas.',
    tronco_requisitos_duros: ['quirofano', 'guardias', 'agudo'],
    flags_conflicto_tipicos: ['aversion_quirofano', 'no_guardias'],
    alternativas_si_no_toleras_tronco: ['Rehab:si prefieres no quirúrgico']
  },

  // =====================================================
  // SUBESPECIALIDADES
  // =====================================================
  {
    destino_id: 'D01',
    destino_nombre: 'Cardiología Intervencionista',
    categoria: 'ClinicaProcedimental',
    troncos_habilitantes: ['medicina_interna'],
    descripcion_dia_a_dia: 'Cateterismos, angioplastias, hemodinamia, guardias, decisiones rápidas.',
    tronco_requisitos_duros: ['guardias', 'hospital', 'agudo', 'procedimientos'],
    flags_conflicto_tipicos: ['no_guardias', 'aversion_quirofano'],
    alternativas_si_no_toleras_tronco: ['IMG:Intervencionismo', 'ANES:Dolor/Crítica', 'URG:Crítica']
  },
  {
    destino_id: 'D02',
    destino_nombre: 'Cardiología Clínica',
    categoria: 'Clinica',
    troncos_habilitantes: ['medicina_interna'],
    descripcion_dia_a_dia: 'Consulta + hospital, EKG/eco, manejo crónico, hospitalizaciones.',
    tronco_requisitos_duros: ['hospital', 'cronicidad', 'toma_decisiones'],
    flags_conflicto_tipicos: ['no_guardias'],
    alternativas_si_no_toleras_tronco: ['MF:Crónicos', 'IMG:Cardioimagen', 'URG:si te gusta agudo']
  },
  {
    destino_id: 'D03',
    destino_nombre: 'Electrofisiología',
    categoria: 'ClinicaProcedimental',
    troncos_habilitantes: ['medicina_interna'],
    descripcion_dia_a_dia: 'Ablaciones, marcapasos, guardias selectivas, tecnología.',
    tronco_requisitos_duros: ['procedimientos', 'tecnologia', 'hospital'],
    flags_conflicto_tipicos: ['no_guardias'],
    alternativas_si_no_toleras_tronco: ['IMG:Intervencionismo', 'ANES:Crítica']
  },
  {
    destino_id: 'D04',
    destino_nombre: 'Nefrología',
    categoria: 'Clinica',
    troncos_habilitantes: ['medicina_interna'],
    descripcion_dia_a_dia: 'ERC, diálisis, trasplante (según sede), hospital + continuidad.',
    tronco_requisitos_duros: ['hospital', 'cronicidad', 'decisiones_complejas'],
    flags_conflicto_tipicos: ['no_guardias'],
    alternativas_si_no_toleras_tronco: ['MF:Crónicos', 'URG:si prefieres agudo']
  },
  {
    destino_id: 'D05',
    destino_nombre: 'Gastroenterología con Endoscopia',
    categoria: 'ClinicaProcedimental',
    troncos_habilitantes: ['medicina_interna'],
    descripcion_dia_a_dia: 'Endoscopia, sangrado, consulta, procedimientos frecuentes.',
    tronco_requisitos_duros: ['procedimientos', 'hospital'],
    flags_conflicto_tipicos: ['aversion_procedimientos'],
    alternativas_si_no_toleras_tronco: ['IMG:Intervencionismo', 'CG:Endoscopia/quirúrgica']
  },
  {
    destino_id: 'D06',
    destino_nombre: 'Reumatología',
    categoria: 'Clinica',
    troncos_habilitantes: ['medicina_interna'],
    descripcion_dia_a_dia: 'Consulta longitudinal, autoinmunidad, inmunosupresión.',
    tronco_requisitos_duros: ['consulta', 'cronicidad', 'cognitivo'],
    flags_conflicto_tipicos: [],
    alternativas_si_no_toleras_tronco: ['PSIQ:si te gusta relación', 'MF:crónicos']
  },
  {
    destino_id: 'D07',
    destino_nombre: 'Hematología',
    categoria: 'Clinica',
    troncos_habilitantes: ['medicina_interna'],
    descripcion_dia_a_dia: 'Hospital, anemia/cáncer/sangrado, decisiones complejas.',
    tronco_requisitos_duros: ['hospital', 'cognitivo'],
    flags_conflicto_tipicos: ['no_guardias'],
    alternativas_si_no_toleras_tronco: ['Patología Clínica:enfoque laboratorio']
  },
  {
    destino_id: 'D08',
    destino_nombre: 'Infectología',
    categoria: 'Clinica',
    troncos_habilitantes: ['medicina_interna'],
    descripcion_dia_a_dia: 'Hospital, antibióticos, brotes, casos complejos.',
    tronco_requisitos_duros: ['hospital', 'guardias', 'cognitivo'],
    flags_conflicto_tipicos: ['no_guardias'],
    alternativas_si_no_toleras_tronco: ['Epidemiología/Preventiva:brotes sin guardias']
  },
  {
    destino_id: 'D09',
    destino_nombre: 'Endocrinología',
    categoria: 'Clinica',
    troncos_habilitantes: ['medicina_interna'],
    descripcion_dia_a_dia: 'Consulta, diabetes/tiroides, seguimiento largo.',
    tronco_requisitos_duros: ['consulta', 'cronicidad'],
    flags_conflicto_tipicos: [],
    alternativas_si_no_toleras_tronco: ['MF:diabetes', 'Medicina del Trabajo']
  },
  {
    destino_id: 'D10',
    destino_nombre: 'Neumología (clínica)',
    categoria: 'Clinica',
    troncos_habilitantes: ['medicina_interna'],
    descripcion_dia_a_dia: 'EPOC/asma, sueño, hospital por exacerbaciones.',
    tronco_requisitos_duros: ['hospital', 'cronicidad'],
    flags_conflicto_tipicos: ['no_guardias'],
    alternativas_si_no_toleras_tronco: ['MF:respiratorio', 'IMG:si te gusta imagen']
  },
  {
    destino_id: 'D11',
    destino_nombre: 'Medicina Intensiva (adulto)',
    categoria: 'Critica',
    troncos_habilitantes: ['medicina_interna', 'urgencias', 'anestesiologia'],
    descripcion_dia_a_dia: 'UCI, ventilación, choque, alta presión, guardias.',
    tronco_requisitos_duros: ['guardias', 'agudo', 'hospital'],
    flags_conflicto_tipicos: ['no_guardias'],
    alternativas_si_no_toleras_tronco: ['IMG:Intervencionismo', 'ANES:Dolor (menos guardias)']
  },
  {
    destino_id: 'D12',
    destino_nombre: 'Urgencias Críticas / Trauma',
    categoria: 'Critica',
    troncos_habilitantes: ['urgencias'],
    descripcion_dia_a_dia: 'Área de choque, politrauma, decisiones rápidas, turnos pesados.',
    tronco_requisitos_duros: ['guardias', 'agudo'],
    flags_conflicto_tipicos: ['no_guardias'],
    alternativas_si_no_toleras_tronco: ['ANES:crítica', 'CG:trauma quirúrgico']
  },
  {
    destino_id: 'D13',
    destino_nombre: 'Toxicología Clínica',
    categoria: 'Critica',
    troncos_habilitantes: ['urgencias'],
    descripcion_dia_a_dia: 'Intoxicaciones, antídotos, guardias, urgencias.',
    tronco_requisitos_duros: ['guardias', 'agudo'],
    flags_conflicto_tipicos: ['no_guardias'],
    alternativas_si_no_toleras_tronco: ['Epidemiología:salud pública']
  },
  {
    destino_id: 'D14',
    destino_nombre: 'Radiología General',
    categoria: 'Imagen',
    troncos_habilitantes: ['imagenologia'],
    descripcion_dia_a_dia: 'Lectura de estudios, hallazgos, trabajo en pantalla, menos emocional.',
    tronco_requisitos_duros: ['pantalla', 'imagen'],
    flags_conflicto_tipicos: ['aversion_radiacion'],
    alternativas_si_no_toleras_tronco: ['MI:cognitivo', 'Patología:diagnóstico por muestras']
  },
  {
    destino_id: 'D15',
    destino_nombre: 'Neuroimagen',
    categoria: 'Imagen',
    troncos_habilitantes: ['imagenologia'],
    descripcion_dia_a_dia: 'Alta carga cognitiva, lectura compleja, urgencias neuro.',
    tronco_requisitos_duros: ['pantalla', 'imagen', 'cognitivo'],
    flags_conflicto_tipicos: ['aversion_radiacion'],
    alternativas_si_no_toleras_tronco: ['MI:neurología', 'PSIQ (si interés neurocog)']
  },
  {
    destino_id: 'D16',
    destino_nombre: 'Radiología Intervencionista',
    categoria: 'Procedimental',
    troncos_habilitantes: ['imagenologia'],
    descripcion_dia_a_dia: 'Procedimientos guiados por imagen, guardias variables.',
    tronco_requisitos_duros: ['procedimientos', 'pantalla', 'hospital'],
    flags_conflicto_tipicos: ['aversion_radiacion', 'aversion_procedimientos'],
    alternativas_si_no_toleras_tronco: ['ANES:procedimientos', 'CG:quirúrgica']
  },
  {
    destino_id: 'D17',
    destino_nombre: 'Medicina Nuclear',
    categoria: 'Imagen',
    troncos_habilitantes: ['imagenologia'],
    descripcion_dia_a_dia: 'Estudios funcionales, radiofármacos, trabajo tecnológico.',
    tronco_requisitos_duros: ['radiacion', 'tecnologia', 'pantalla'],
    flags_conflicto_tipicos: ['aversion_radiacion'],
    alternativas_si_no_toleras_tronco: ['IMG:si prefieres menos radiofármacos']
  },
  {
    destino_id: 'D18',
    destino_nombre: 'Radio Oncología',
    categoria: 'Oncologia',
    troncos_habilitantes: ['imagenologia'],
    descripcion_dia_a_dia: 'Planeación y tratamiento con radiación, seguimiento.',
    tronco_requisitos_duros: ['radiacion', 'tecnologia'],
    flags_conflicto_tipicos: ['aversion_radiacion'],
    alternativas_si_no_toleras_tronco: ['MI:Onco médica']
  },
  {
    destino_id: 'D19',
    destino_nombre: 'Psiquiatría de Adultos',
    categoria: 'SaludMental',
    troncos_habilitantes: ['psiquiatria'],
    descripcion_dia_a_dia: 'Entrevista, psicofármacos, relación longitudinal, carga emocional.',
    tronco_requisitos_duros: ['emocional', 'comunicacion'],
    flags_conflicto_tipicos: ['aversion_emocional'],
    alternativas_si_no_toleras_tronco: ['MF:si prefieres menos psiquis', 'Calidad:si te gusta sistema']
  },
  {
    destino_id: 'D20',
    destino_nombre: 'Psiquiatría Infantil',
    categoria: 'SaludMental',
    troncos_habilitantes: ['psiquiatria'],
    descripcion_dia_a_dia: 'Niños/adolescentes, familia, escuela, alta emocional.',
    tronco_requisitos_duros: ['emocional', 'pediatria'],
    flags_conflicto_tipicos: ['no_ninos', 'aversion_emocional'],
    alternativas_si_no_toleras_tronco: ['Psico adulto', 'Pediatría del desarrollo']
  },
  {
    destino_id: 'D21',
    destino_nombre: 'Adicciones',
    categoria: 'SaludMental',
    troncos_habilitantes: ['psiquiatria'],
    descripcion_dia_a_dia: 'Programas, recaídas, comorbilidad, trabajo interdisciplinario.',
    tronco_requisitos_duros: ['emocional', 'sistema'],
    flags_conflicto_tipicos: ['aversion_emocional'],
    alternativas_si_no_toleras_tronco: ['Epidemiología/Preventiva']
  },
  {
    destino_id: 'D22',
    destino_nombre: 'Geriatría',
    categoria: 'Clinica',
    troncos_habilitantes: ['medicina_interna'],
    descripcion_dia_a_dia: 'Fragilidad, polifarmacia, crónicos, alta comunicación.',
    tronco_requisitos_duros: ['cronicidad', 'emocional', 'consulta'],
    flags_conflicto_tipicos: ['aversion_emocional'],
    alternativas_si_no_toleras_tronco: ['MF:crónicos']
  },
  {
    destino_id: 'D23',
    destino_nombre: 'Medicina Paliativa',
    categoria: 'Clinica',
    troncos_habilitantes: ['medicina_interna', 'anestesiologia'],
    descripcion_dia_a_dia: 'Síntomas, dolor, final de vida, comunicación intensa.',
    tronco_requisitos_duros: ['emocional', 'comunicacion'],
    flags_conflicto_tipicos: ['aversion_emocional'],
    alternativas_si_no_toleras_tronco: ['ANES:Dolor (menos duelo)', 'Calidad']
  },
  {
    destino_id: 'D24',
    destino_nombre: 'Anestesia Cardiaca / Alta Especialidad',
    categoria: 'Procedimental',
    troncos_habilitantes: ['anestesiologia'],
    descripcion_dia_a_dia: 'Quirófano complejo, monitorización, procedimientos.',
    tronco_requisitos_duros: ['quirofano', 'procedimientos'],
    flags_conflicto_tipicos: ['aversion_quirofano'],
    alternativas_si_no_toleras_tronco: ['IMG:Intervencionismo', 'URG:crítica']
  },
  {
    destino_id: 'D25',
    destino_nombre: 'Algología / Dolor',
    categoria: 'Procedimental',
    troncos_habilitantes: ['anestesiologia'],
    descripcion_dia_a_dia: 'Consulta + procedimientos (bloqueos), crónico.',
    tronco_requisitos_duros: ['procedimientos'],
    flags_conflicto_tipicos: ['aversion_procedimientos'],
    alternativas_si_no_toleras_tronco: ['Rehab:si prefieres no invasivo']
  },
  {
    destino_id: 'D26',
    destino_nombre: 'Rehabilitación (físico-funcional)',
    categoria: 'Rehab',
    troncos_habilitantes: ['medicina_familiar'],
    descripcion_dia_a_dia: 'Consulta, funcionalidad, equipos, longitudinal.',
    tronco_requisitos_duros: ['longitudinal', 'consulta'],
    flags_conflicto_tipicos: [],
    alternativas_si_no_toleras_tronco: ['MF:crónicos', 'Deporte']
  },
  {
    destino_id: 'D27',
    destino_nombre: 'Medicina del Deporte',
    categoria: 'Ambulatorio',
    troncos_habilitantes: ['medicina_familiar', 'traumatologia_ortopedia'],
    descripcion_dia_a_dia: 'Lesiones deportivas, rendimiento, consulta, prevención.',
    tronco_requisitos_duros: ['consulta', 'procedimientos_ligeros'],
    flags_conflicto_tipicos: [],
    alternativas_si_no_toleras_tronco: ['Rehab']
  },
  {
    destino_id: 'D28',
    destino_nombre: 'Ortopedia de Mano',
    categoria: 'Quirurgica',
    troncos_habilitantes: ['traumatologia_ortopedia'],
    descripcion_dia_a_dia: 'Cirugía fina, trauma mano, técnica.',
    tronco_requisitos_duros: ['quirofano', 'procedimientos'],
    flags_conflicto_tipicos: ['aversion_quirofano'],
    alternativas_si_no_toleras_tronco: ['IMG:Intervencionismo', 'Rehab (mano no quirúrgica)']
  },
  {
    destino_id: 'D29',
    destino_nombre: 'Columna (Ortopedia)',
    categoria: 'Quirurgica',
    troncos_habilitantes: ['traumatologia_ortopedia'],
    descripcion_dia_a_dia: 'Cirugía columna, alta complejidad, guardias trauma.',
    tronco_requisitos_duros: ['quirofano', 'procedimientos', 'guardias'],
    flags_conflicto_tipicos: ['no_guardias', 'aversion_quirofano'],
    alternativas_si_no_toleras_tronco: ['Rehab', 'Dolor']
  },
  {
    destino_id: 'D30',
    destino_nombre: 'Ortopedia Pediátrica',
    categoria: 'Quirurgica',
    troncos_habilitantes: ['traumatologia_ortopedia'],
    descripcion_dia_a_dia: 'Niños + quirófano + seguimiento.',
    tronco_requisitos_duros: ['pediatria', 'quirofano'],
    flags_conflicto_tipicos: ['no_ninos', 'aversion_quirofano'],
    alternativas_si_no_toleras_tronco: ['TO adultos', 'Rehab pediátrica']
  },
  {
    destino_id: 'D31',
    destino_nombre: 'Trauma Ortopédico (alta energía)',
    categoria: 'Quirurgica',
    troncos_habilitantes: ['traumatologia_ortopedia'],
    descripcion_dia_a_dia: 'Guardias, politrauma, urgencias.',
    tronco_requisitos_duros: ['guardias', 'agudo', 'quirofano'],
    flags_conflicto_tipicos: ['no_guardias', 'aversion_quirofano'],
    alternativas_si_no_toleras_tronco: ['URG:trauma sin quirófano']
  },
  {
    destino_id: 'D32',
    destino_nombre: 'Materno-Fetal / Perinatología',
    categoria: 'Obstetrica',
    troncos_habilitantes: ['ginecologia_obstetricia'],
    descripcion_dia_a_dia: 'Embarazo alto riesgo, urgencias obstétricas, guardias.',
    tronco_requisitos_duros: ['guardias', 'agudo', 'mujer'],
    flags_conflicto_tipicos: ['no_guardias'],
    alternativas_si_no_toleras_tronco: ['MF:salud reproductiva preventiva']
  },
  {
    destino_id: 'D33',
    destino_nombre: 'Reproducción Humana',
    categoria: 'Ambulatorio',
    troncos_habilitantes: ['ginecologia_obstetricia'],
    descripcion_dia_a_dia: 'Consulta, procedimientos programados, menos urgencias.',
    tronco_requisitos_duros: ['consulta', 'procedimientos'],
    flags_conflicto_tipicos: ['aversion_procedimientos'],
    alternativas_si_no_toleras_tronco: ['MF:consulta preventiva']
  },
  {
    destino_id: 'D34',
    destino_nombre: 'Oncogine',
    categoria: 'Quirurgica',
    troncos_habilitantes: ['ginecologia_obstetricia'],
    descripcion_dia_a_dia: 'Cirugía + cáncer, hospital, decisiones duras.',
    tronco_requisitos_duros: ['quirofano', 'emocional', 'hospital'],
    flags_conflicto_tipicos: ['aversion_quirofano', 'aversion_emocional'],
    alternativas_si_no_toleras_tronco: ['MI:Onco médica']
  },
  {
    destino_id: 'D35',
    destino_nombre: 'Uroginecología',
    categoria: 'Quirurgica',
    troncos_habilitantes: ['ginecologia_obstetricia'],
    descripcion_dia_a_dia: 'Cirugía de piso pélvico, consulta + quirófano.',
    tronco_requisitos_duros: ['quirofano', 'consulta'],
    flags_conflicto_tipicos: ['aversion_quirofano'],
    alternativas_si_no_toleras_tronco: ['Rehab piso pélvico']
  },
  {
    destino_id: 'D36',
    destino_nombre: 'Neonatología',
    categoria: 'Critica',
    troncos_habilitantes: ['pediatria'],
    descripcion_dia_a_dia: 'UCIN, ventilación, guardias, alta presión.',
    tronco_requisitos_duros: ['guardias', 'agudo', 'pediatria'],
    flags_conflicto_tipicos: ['no_guardias', 'no_ninos'],
    alternativas_si_no_toleras_tronco: ['Pediatría ambulatoria']
  },
  {
    destino_id: 'D37',
    destino_nombre: 'Pediatría Ambulatoria / Primer contacto',
    categoria: 'Pediatria',
    troncos_habilitantes: ['pediatria'],
    descripcion_dia_a_dia: 'Consulta, crecimiento, vacunas, continuidad.',
    tronco_requisitos_duros: ['pediatria', 'consulta', 'longitudinal'],
    flags_conflicto_tipicos: ['no_ninos'],
    alternativas_si_no_toleras_tronco: ['MF:primer contacto adultos']
  },
  {
    destino_id: 'D38',
    destino_nombre: 'Imagen de Mama',
    categoria: 'Imagen',
    troncos_habilitantes: ['imagenologia'],
    descripcion_dia_a_dia: 'Lectura mamografías/US, programa de tamizaje, comunicación delicada.',
    tronco_requisitos_duros: ['pantalla', 'imagen', 'emocional_media'],
    flags_conflicto_tipicos: ['aversion_radiacion'],
    alternativas_si_no_toleras_tronco: ['MF/GO:salud mujer']
  },
  {
    destino_id: 'D39',
    destino_nombre: 'Calidad y Seguridad del Paciente',
    categoria: 'Sistema',
    troncos_habilitantes: ['medicina_familiar'],
    descripcion_dia_a_dia: 'Mejora procesos, indicadores, comités, menos guardias.',
    tronco_requisitos_duros: ['sistema', 'gestion'],
    flags_conflicto_tipicos: [],
    alternativas_si_no_toleras_tronco: ['Epidemiología/Preventiva']
  },
  {
    destino_id: 'D40',
    destino_nombre: 'Epidemiología y Salud Pública',
    categoria: 'Sistema',
    troncos_habilitantes: ['medicina_familiar'],
    descripcion_dia_a_dia: 'Brotes, vigilancia, investigación, políticas, población.',
    tronco_requisitos_duros: ['sistema', 'poblacional'],
    flags_conflicto_tipicos: [],
    alternativas_si_no_toleras_tronco: ['Calidad', 'Trabajo y ambiental']
  },
  // =====================================================
  // SUBESPECIALIDADES ADICIONALES
  // =====================================================
  {
    destino_id: 'D41',
    destino_nombre: 'Alergia e Inmunología Clínica',
    categoria: 'Clinica',
    troncos_habilitantes: ['medicina_interna'],
    descripcion_dia_a_dia: 'Consulta, pruebas alérgicas, inmunoterapia, asma, autoinmunidad.',
    tronco_requisitos_duros: ['consulta', 'cognitivo'],
    flags_conflicto_tipicos: [],
    alternativas_si_no_toleras_tronco: ['Reumatología:autoinmunidad', 'Neumología:asma']
  },
  {
    destino_id: 'D42',
    destino_nombre: 'Alergia e Inmunología Clínica Pediátrica',
    categoria: 'Clinica',
    troncos_habilitantes: ['pediatria'],
    descripcion_dia_a_dia: 'Consulta pediátrica, alergias infantiles, inmunodeficiencias.',
    tronco_requisitos_duros: ['pediatria', 'consulta'],
    flags_conflicto_tipicos: ['no_ninos'],
    alternativas_si_no_toleras_tronco: ['Alergia adultos:sin niños']
  },
  {
    destino_id: 'D43',
    destino_nombre: 'Anestesiología Pediátrica',
    categoria: 'ClinicaProcedimental',
    troncos_habilitantes: ['anestesiologia'],
    descripcion_dia_a_dia: 'Anestesia en niños, quirófano pediátrico, procedimientos.',
    tronco_requisitos_duros: ['quirofano', 'pediatria', 'procedimientos'],
    flags_conflicto_tipicos: ['no_ninos', 'aversion_quirofano'],
    alternativas_si_no_toleras_tronco: ['Anestesia adultos:sin niños']
  },
  {
    destino_id: 'D44',
    destino_nombre: 'Angiología y Cirugía Vascular',
    categoria: 'ClinicaProcedimental',
    troncos_habilitantes: ['cirugia_general'],
    descripcion_dia_a_dia: 'Cirugía vascular, varicosidades, isquemia, procedimientos endovasculares.',
    tronco_requisitos_duros: ['quirofano', 'procedimientos'],
    flags_conflicto_tipicos: ['aversion_quirofano'],
    alternativas_si_no_toleras_tronco: ['MI:vascular sin quirófano']
  },
  {
    destino_id: 'D45',
    destino_nombre: 'Cardiología',
    categoria: 'Clinica',
    troncos_habilitantes: ['medicina_interna'],
    descripcion_dia_a_dia: 'Consulta + hospital, EKG/eco, manejo crónico, hospitalizaciones.',
    tronco_requisitos_duros: ['hospital', 'cronicidad', 'toma_decisiones'],
    flags_conflicto_tipicos: ['no_guardias'],
    alternativas_si_no_toleras_tronco: ['MF:Crónicos', 'IMG:Cardioimagen']
  },
  {
    destino_id: 'D46',
    destino_nombre: 'Cirugía Cardiotorácica',
    categoria: 'ClinicaProcedimental',
    troncos_habilitantes: ['cirugia_general'],
    descripcion_dia_a_dia: 'Cirugía de corazón y tórax, bypass, válvulas, alta complejidad.',
    tronco_requisitos_duros: ['quirofano', 'agudo', 'guardias'],
    flags_conflicto_tipicos: ['aversion_quirofano', 'no_guardias'],
    alternativas_si_no_toleras_tronco: ['Cardiología Clínica:sin quirófano']
  },
  {
    destino_id: 'D47',
    destino_nombre: 'Cirugía Oncológica',
    categoria: 'ClinicaProcedimental',
    troncos_habilitantes: ['cirugia_general'],
    descripcion_dia_a_dia: 'Resecciones tumorales, estadificación, quirófano oncológico.',
    tronco_requisitos_duros: ['quirofano', 'hospital'],
    flags_conflicto_tipicos: ['aversion_quirofano'],
    alternativas_si_no_toleras_tronco: ['Oncología Médica:sin quirófano']
  },
  {
    destino_id: 'D48',
    destino_nombre: 'Cirugía Pediátrica',
    categoria: 'ClinicaProcedimental',
    troncos_habilitantes: ['cirugia_general'],
    descripcion_dia_a_dia: 'Cirugía en niños, malformaciones, urgencias pediátricas quirúrgicas.',
    tronco_requisitos_duros: ['quirofano', 'pediatria', 'guardias'],
    flags_conflicto_tipicos: ['no_ninos', 'aversion_quirofano'],
    alternativas_si_no_toleras_tronco: ['CG adultos:sin niños']
  },
  {
    destino_id: 'D49',
    destino_nombre: 'Cirugía Plástica y Reconstructiva',
    categoria: 'ClinicaProcedimental',
    troncos_habilitantes: ['cirugia_general'],
    descripcion_dia_a_dia: 'Reconstrucción, microcirugía, quemados, estética.',
    tronco_requisitos_duros: ['quirofano', 'procedimientos'],
    flags_conflicto_tipicos: ['aversion_quirofano'],
    alternativas_si_no_toleras_tronco: ['Dermatología:procedimientos menores']
  },
  {
    destino_id: 'D50',
    destino_nombre: 'Coloproctología',
    categoria: 'ClinicaProcedimental',
    troncos_habilitantes: ['cirugia_general'],
    descripcion_dia_a_dia: 'Cirugía colorrectal, proctología, colonoscopia, consulta.',
    tronco_requisitos_duros: ['quirofano', 'procedimientos'],
    flags_conflicto_tipicos: ['aversion_quirofano'],
    alternativas_si_no_toleras_tronco: ['Gastroenterología:endoscopia sin quirófano']
  },
  {
    destino_id: 'D51',
    destino_nombre: 'Gastroenterología y Nutrición Pediátrica',
    categoria: 'Clinica',
    troncos_habilitantes: ['pediatria'],
    descripcion_dia_a_dia: 'Consulta pediátrica digestiva, nutrición, endoscopia infantil.',
    tronco_requisitos_duros: ['pediatria', 'consulta'],
    flags_conflicto_tipicos: ['no_ninos'],
    alternativas_si_no_toleras_tronco: ['Gastro adultos:sin niños']
  },
  {
    destino_id: 'D52',
    destino_nombre: 'Ginecología Oncológica',
    categoria: 'ClinicaProcedimental',
    troncos_habilitantes: ['ginecologia_obstetricia'],
    descripcion_dia_a_dia: 'Cáncer ginecológico, cirugía oncológica, quimioterapia.',
    tronco_requisitos_duros: ['quirofano', 'hospital'],
    flags_conflicto_tipicos: ['aversion_quirofano'],
    alternativas_si_no_toleras_tronco: ['Oncología Médica:sin quirófano']
  },
  {
    destino_id: 'D53',
    destino_nombre: 'Hematología Pediátrica',
    categoria: 'Clinica',
    troncos_habilitantes: ['pediatria'],
    descripcion_dia_a_dia: 'Leucemias infantiles, anemias, coagulopatías, hospital pediátrico.',
    tronco_requisitos_duros: ['pediatria', 'hospital', 'cognitivo'],
    flags_conflicto_tipicos: ['no_ninos'],
    alternativas_si_no_toleras_tronco: ['Hematología adultos:sin niños']
  },
  {
    destino_id: 'D54',
    destino_nombre: 'Infectología Pediátrica',
    categoria: 'Clinica',
    troncos_habilitantes: ['pediatria'],
    descripcion_dia_a_dia: 'Infecciones pediátricas, antibióticos, inmunodeficiencias, hospital.',
    tronco_requisitos_duros: ['pediatria', 'hospital', 'cognitivo'],
    flags_conflicto_tipicos: ['no_ninos'],
    alternativas_si_no_toleras_tronco: ['Infectología adultos:sin niños']
  },
  {
    destino_id: 'D55',
    destino_nombre: 'Medicina del Enfermo Pediátrico en Estado Crítico',
    categoria: 'Critica',
    troncos_habilitantes: ['pediatria'],
    descripcion_dia_a_dia: 'UCI pediátrica, ventilación, choque, alta presión, guardias.',
    tronco_requisitos_duros: ['pediatria', 'guardias', 'agudo'],
    flags_conflicto_tipicos: ['no_ninos', 'no_guardias'],
    alternativas_si_no_toleras_tronco: ['UCI adultos:sin niños']
  },
  {
    destino_id: 'D56',
    destino_nombre: 'Medicina del Enfermo en Estado Crítico',
    categoria: 'Critica',
    troncos_habilitantes: ['medicina_interna', 'urgencias', 'anestesiologia'],
    descripcion_dia_a_dia: 'UCI, ventilación, choque, alta presión, guardias.',
    tronco_requisitos_duros: ['guardias', 'agudo', 'hospital'],
    flags_conflicto_tipicos: ['no_guardias'],
    alternativas_si_no_toleras_tronco: ['IMG:Intervencionismo', 'ANES:Dolor']
  },
  {
    destino_id: 'D57',
    destino_nombre: 'Medicina Paliativa y del Dolor',
    categoria: 'Clinica',
    troncos_habilitantes: ['anestesiologia', 'medicina_interna'],
    descripcion_dia_a_dia: 'Manejo del dolor crónico, cuidados paliativos, acompañamiento.',
    tronco_requisitos_duros: ['emocional', 'comunicacion', 'consulta'],
    flags_conflicto_tipicos: ['aversion_emocional'],
    alternativas_si_no_toleras_tronco: ['MI:si prefieres más agudo']
  },
  {
    destino_id: 'D58',
    destino_nombre: 'Nefrología Pediátrica',
    categoria: 'Clinica',
    troncos_habilitantes: ['pediatria'],
    descripcion_dia_a_dia: 'Enfermedades renales infantiles, diálisis pediátrica.',
    tronco_requisitos_duros: ['pediatria', 'hospital'],
    flags_conflicto_tipicos: ['no_ninos'],
    alternativas_si_no_toleras_tronco: ['Nefrología adultos:sin niños']
  },
  {
    destino_id: 'D59',
    destino_nombre: 'Neumología Pediátrica',
    categoria: 'Clinica',
    troncos_habilitantes: ['pediatria'],
    descripcion_dia_a_dia: 'Asma infantil, fibrosis quística, infecciones respiratorias pediátricas.',
    tronco_requisitos_duros: ['pediatria', 'hospital'],
    flags_conflicto_tipicos: ['no_ninos'],
    alternativas_si_no_toleras_tronco: ['Neumología adultos:sin niños']
  },
  {
    destino_id: 'D60',
    destino_nombre: 'Neuroanestesiología',
    categoria: 'ClinicaProcedimental',
    troncos_habilitantes: ['anestesiologia'],
    descripcion_dia_a_dia: 'Anestesia en neurocirugía, monitoreo neurofisiológico.',
    tronco_requisitos_duros: ['quirofano', 'procedimientos', 'tecnologia'],
    flags_conflicto_tipicos: ['aversion_quirofano'],
    alternativas_si_no_toleras_tronco: ['Anestesia general:menos especializado']
  },
  {
    destino_id: 'D61',
    destino_nombre: 'Neurocirugía',
    categoria: 'ClinicaProcedimental',
    troncos_habilitantes: ['cirugia_general'],
    descripcion_dia_a_dia: 'Cirugía cerebral y espinal, alta complejidad, guardias pesadas.',
    tronco_requisitos_duros: ['quirofano', 'guardias', 'agudo'],
    flags_conflicto_tipicos: ['aversion_quirofano', 'no_guardias'],
    alternativas_si_no_toleras_tronco: ['Neurología:sin quirófano']
  },
  {
    destino_id: 'D62',
    destino_nombre: 'Neurocirugía Pediátrica',
    categoria: 'ClinicaProcedimental',
    troncos_habilitantes: ['cirugia_general'],
    descripcion_dia_a_dia: 'Neurocirugía en niños, malformaciones, hidrocefalia.',
    tronco_requisitos_duros: ['quirofano', 'pediatria', 'guardias'],
    flags_conflicto_tipicos: ['no_ninos', 'aversion_quirofano'],
    alternativas_si_no_toleras_tronco: ['Neurocirugía adultos:sin niños']
  },
  {
    destino_id: 'D63',
    destino_nombre: 'Neurofisiología Clínica',
    categoria: 'Clinica',
    troncos_habilitantes: ['medicina_interna'],
    descripcion_dia_a_dia: 'Electroencefalografía, neuroconducciones, potenciales evocados.',
    tronco_requisitos_duros: ['tecnologia', 'cognitivo'],
    flags_conflicto_tipicos: [],
    alternativas_si_no_toleras_tronco: ['Neurología:enfoque clínico']
  },
  {
    destino_id: 'D64',
    destino_nombre: 'Neurología',
    categoria: 'Clinica',
    troncos_habilitantes: ['medicina_interna'],
    descripcion_dia_a_dia: 'Consulta + hospital, EVC, epilepsia, enfermedades neurodegenerativas.',
    tronco_requisitos_duros: ['hospital', 'cognitivo'],
    flags_conflicto_tipicos: ['no_guardias'],
    alternativas_si_no_toleras_tronco: ['Psiquiatría:si prefieres mente']
  },
  {
    destino_id: 'D65',
    destino_nombre: 'Oncología Médica',
    categoria: 'Clinica',
    troncos_habilitantes: ['medicina_interna'],
    descripcion_dia_a_dia: 'Quimioterapia, inmunoterapia, seguimiento oncológico, hospital.',
    tronco_requisitos_duros: ['hospital', 'emocional', 'cognitivo'],
    flags_conflicto_tipicos: ['aversion_emocional'],
    alternativas_si_no_toleras_tronco: ['Hematología:menos emocional']
  },
  {
    destino_id: 'D66',
    destino_nombre: 'Oncología Pediátrica',
    categoria: 'Clinica',
    troncos_habilitantes: ['pediatria'],
    descripcion_dia_a_dia: 'Cáncer infantil, quimioterapia, hospital pediátrico.',
    tronco_requisitos_duros: ['pediatria', 'hospital', 'emocional'],
    flags_conflicto_tipicos: ['no_ninos', 'aversion_emocional'],
    alternativas_si_no_toleras_tronco: ['Oncología adultos:sin niños']
  },
  {
    destino_id: 'D67',
    destino_nombre: 'Otorrinolaringología Pediátrica',
    categoria: 'ClinicaProcedimental',
    troncos_habilitantes: ['otorrinolaringologia'],
    descripcion_dia_a_dia: 'Cirugía ORL en niños, amígdalas, oído, vía aérea.',
    tronco_requisitos_duros: ['quirofano', 'pediatria'],
    flags_conflicto_tipicos: ['no_ninos', 'aversion_quirofano'],
    alternativas_si_no_toleras_tronco: ['ORL adultos:sin niños']
  },
  {
    destino_id: 'D68',
    destino_nombre: 'Reumatología Pediátrica',
    categoria: 'Clinica',
    troncos_habilitantes: ['pediatria'],
    descripcion_dia_a_dia: 'Enfermedades autoinmunes en niños, artritis juvenil, lupus pediátrico.',
    tronco_requisitos_duros: ['pediatria', 'consulta', 'cognitivo'],
    flags_conflicto_tipicos: ['no_ninos'],
    alternativas_si_no_toleras_tronco: ['Reumatología adultos:sin niños']
  },
  {
    destino_id: 'D69',
    destino_nombre: 'Terapia Endovascular Neurológica',
    categoria: 'ClinicaProcedimental',
    troncos_habilitantes: ['medicina_interna', 'imagenologia'],
    descripcion_dia_a_dia: 'Intervenciones endovasculares cerebrales, trombectomías, aneurismas.',
    tronco_requisitos_duros: ['procedimientos', 'tecnologia', 'agudo'],
    flags_conflicto_tipicos: ['aversion_procedimientos'],
    alternativas_si_no_toleras_tronco: ['Neurología:sin procedimientos']
  },
  {
    destino_id: 'D70',
    destino_nombre: 'Urgencias Pediátricas',
    categoria: 'Critica',
    troncos_habilitantes: ['pediatria'],
    descripcion_dia_a_dia: 'Urgencias en niños, decisiones rápidas, guardias, alta presión.',
    tronco_requisitos_duros: ['pediatria', 'guardias', 'agudo'],
    flags_conflicto_tipicos: ['no_ninos', 'no_guardias'],
    alternativas_si_no_toleras_tronco: ['Urgencias adultos:sin niños']
  },
  {
    destino_id: 'D71',
    destino_nombre: 'Urología',
    categoria: 'ClinicaProcedimental',
    troncos_habilitantes: ['cirugia_general'],
    descripcion_dia_a_dia: 'Cirugía urológica, litiasis, próstata, endourología.',
    tronco_requisitos_duros: ['quirofano', 'procedimientos'],
    flags_conflicto_tipicos: ['aversion_quirofano'],
    alternativas_si_no_toleras_tronco: ['Nefrología:sin quirófano']
  },
  {
    destino_id: 'D72',
    destino_nombre: 'Urología Ginecológica',
    categoria: 'ClinicaProcedimental',
    troncos_habilitantes: ['ginecologia_obstetricia'],
    descripcion_dia_a_dia: 'Piso pélvico, incontinencia, cirugía reconstructiva uroginecológica.',
    tronco_requisitos_duros: ['quirofano', 'procedimientos'],
    flags_conflicto_tipicos: ['aversion_quirofano'],
    alternativas_si_no_toleras_tronco: ['Ginecología general:menos quirúrgico']
  }
];

// =============================================================================
// PENALIZADORES
// =============================================================================
export const PENALIZADORES = {
  aversion_quirofano: { campo_adn: 'quirofano', umbral: 2, penalizacion: -25 },
  no_guardias: { campo_adn: 'agudo', umbral: 2, penalizacion: -20 },
  no_ninos: { campo_adn: 'pediatria', umbral: 2, penalizacion: -30 },
  aversion_emocional: { campo_adn: 'emocional', umbral: 2, penalizacion: -20 },
  aversion_radiacion: { campo_adn: 'imagen', umbral: 2, penalizacion: -15 }
};

// =============================================================================
// PLANTILLAS DE TEXTO (NO MODIFICAR REDACCIÓN)
// =============================================================================
export const PLANTILLAS = {
  RAZONES: (eje1, eje2, eje3) => 
    `Te conviene porque tu perfil es alto en ${eje1} y esta especialidad lo usa mucho. También encaja por ${eje2}. Y en tercer lugar por ${eje3}.`,
  
  BANDERA_ROJA: (factor) => 
    `Ojo: detecté baja tolerancia a ${factor}. Esta especialidad suele requerir ${factor} alto.`,
  
  FRICCION_TRONCO: (destino, tronco, requisitos, flags) => 
    `Para llegar a ${destino}, típicamente necesitas ${tronco}. Ese camino suele implicar: ${requisitos}. Posibles choques detectados: ${flags}. ¿Lo toleras por 3 años?`,
  
  FRICCION_CARDIOLOGIA_INTERVENCIONISTA: 
    'Para llegar aquí, debes amar (o tolerar) 3 años de Medicina Interna. ¿Estás dispuesto a manejar pacientes complejos, EPOC, diabetes, infecciones y guardias antes de tocar un catéter?',
  
  ALTERNATIVAS: (destino, alternativas) => 
    `Si te gusta ${destino} pero NO toleras su tronco, considera estas rutas cercanas: ${alternativas}`,
  
  CONFIANZA_ALTA: 'Siguiente paso: valida con 1 día de shadowing.',
  CONFIANZA_MEDIA: 'Siguiente paso: habla con 2 residentes y repite en modo completo.',
  CONFIANZA_BAJA: 'Siguiente paso: repite en modo completo y haz shadowing en 2 áreas.',
  
  // NUEVAS PLANTILLAS - Puntos clave según perfil OR/procedimientos
  PUNTO_CLAVE_OR_SI: 'Punto clave: te sientes cómodo en quirófano. Eso empuja hacia especialidades con quirófano alto.',
  PUNTO_CLAVE_OR_SIN_OPERAR: 'Punto clave: te gusta el ambiente de quirófano pero sin operar. Eso empuja hacia especialidades como Anestesiología, que están en el quirófano sin ser el cirujano.',
  PUNTO_CLAVE_OR_NO_PROC: 'Punto clave: prefieres fuera de quirófano, pero sí te gustan procedimientos invasivos. Eso empuja hacia especialidades procedimentales no quirúrgicas.',
  PUNTO_CLAVE_OR_NO_CLINICA: 'Punto clave: prefieres fuera de quirófano y sin procedimientos invasivos. Eso empuja hacia especialidades de consulta y seguimiento.',
  
  // Exposición/Calibración
  EXPOSURE_BAJA: 'Nota: tu exposición real a guardias/quirófano es baja. Valida con shadowing antes de decidir.',
  
  // Hard stops
  HARD_STOP_ACTIVADO: (especialidad, factor) => 
    `Se evitó recomendar ${especialidad} como primera opción por choque fuerte con ${factor}.`
};

// =============================================================================
// PESOS DE SCORING (CONFIGURABLES)
// =============================================================================
export const SCORING_WEIGHTS = {
  OR_WEIGHT: 30,           // Peso del componente quirófano
  OR_SIN_OPERAR_BONUS: 20, // Bonus extra para especialidades quirofano=2 + procedimientos altos (Anestesiología)
  OR_SIN_OPERAR_CIRUGIA_PENALTY: 8, // Penalización leve para cirugías puras cuando prefiere "sin operar"
  PROC_WEIGHT_SIMPLE: 15,  // Peso para procedimientos simples
  PROC_WEIGHT_COMPLEJO: 30, // Peso para procedimientos complejos
  DESTINO_BONUS_SIMPLE: 10,
  DESTINO_BONUS_COMPLEJO: 20,
  CLINICA_SIN_PROC_PENALTY: -15,
  CLINICA_LONGITUDINAL_BONUS: 15
};

// =============================================================================
// CATEGORÍAS DE DESTINOS (para bonificaciones)
// =============================================================================
export const CATEGORIAS_PROCEDIMENTALES = ['ClinicaProcedimental', 'Procedimental'];
export const CATEGORIAS_NO_PROCEDIMENTALES = ['Imagen', 'Sistema', 'SaludMental', 'Ambulatorio', 'Clinica'];

// =============================================================================
// MAPEO DE FACTORES PARA BANDERAS ROJAS
// =============================================================================
export const MAPEO_FACTORES = {
  no_guardias: 'guardias/desvelo',
  aversion_quirofano: 'quirófano y sangre',
  no_ninos: 'pacientes pediátricos',
  aversion_emocional: 'carga emocional intensa',
  aversion_radiacion: 'pantallas/radiación/imagen'
};

// =============================================================================
// NOMBRES DE EJES EN ESPAÑOL
// =============================================================================
export const NOMBRES_EJES = {
  agudo: 'Agudo',
  longitudinal: 'Longitudinal',
  cognitivo: 'Cognitivo',
  procedimientos: 'Procedimientos',
  quirofano: 'Quirófano',
  emocional: 'Emocional',
  imagen: 'Imagen',
  sistema: 'Sistema',
  pediatria: 'Pediatría'
};
